import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateExternalLinkTo, LinkTo } from "../../../constants/linkTo";
import { AppTester } from "../../../../supporting";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetCompetitionTabs = () => {

    const isPro = AppTester.isProDeziiign();
    const isProHSE = AppTester.isProHSE();
    const isFashion = AppTester.isFashionDeziiign();
    const isBooksMain = AppTester.isBooksMain();
    const isDezignMain = AppTester.isDeziiignMain();
    const isContinuumSite = AppTester.isContinuumSite();
    const isLectureMediiia = AppTester.isLectureMediiia();
    const isLabDeziiign = AppTester.isLabDeziiign();
    const isStartHSE = AppTester.isStartHSE();

    const { t } = useTranslation();
    const location = useLocation();

    return {
        [NAVBAR_TAB_NAMES.awards]: {
            content: t('nav.competitions'),
            active: location.pathname.startsWith('/awards'),
            target: '_self', 
            disabled: isContinuumSite,
            linkTo: () => {
                if (isLectureMediiia) {
                    return LinkTo.awards
                }
                if (isProHSE) {
                    return process.env.REACT_APP_URL_HSEDESIGN_RU + '/awards'
                }
                if (isDezignMain || isBooksMain || isPro || isLabDeziiign) {
                    return CreateExternalLinkTo.deziiign('/awards')
                }
                return LinkTo.awards
            },
        },
        [NAVBAR_TAB_NAMES.awards_portfolio]: {
            content: t('nav.competitions'),
            linkTo: '/',
        },
    }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateExternalLinkTo, LinkTo } from "../../../constants/linkTo";
import { AppTester } from "../../../../supporting";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetCompetitionTabs = () => {

    const isPro = AppTester.isProDeziiign();
    const isProHSE = AppTester.isProHSE();
    const isFashion = AppTester.isFashionDeziiign();
    const isBooksMain = AppTester.isBooksMain();
    const isDezignMain = AppTester.isDeziiignMain();
    const isContinuumSite = AppTester.isContinuumSite();
    const isLectureMediiia = AppTester.isLectureMediiia();
    const isLabDeziiign = AppTester.isLabDeziiign();
    const isStartHSE = AppTester.isStartHSE();

    const { t } = useTranslation();
    const location = useLocation();

    return {
        [NAVBAR_TAB_NAMES.awards]: {
            content: t('nav.competitions'),
            active: location.pathname.startsWith('/awards'),
            target: '_self', 
            disabled: isContinuumSite,
            linkTo: () => {
                if (isLectureMediiia) {
                    return LinkTo.awards
                }
                if (isProHSE) {
                    return process.env.REACT_APP_URL_HSEDESIGN_RU + '/awards'
                }
                if (isDezignMain || isBooksMain || isPro || isLabDeziiign) {
                    return CreateExternalLinkTo.deziiign('/awards')
                }
                return LinkTo.awards
            },
        },
        [NAVBAR_TAB_NAMES.awards_portfolio]: {
            content: t('nav.competitions'),
            linkTo: '/',
        },
    }
}